"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.technician_jobs = exports.jobs = exports.ingenieur_jobs = exports.experiences = exports.disciplines = void 0;
var ingenieur_jobs = ['Directeur de projet', 'Chef de projet', 'Consultant', 'Ingénieur d\'affaires', 'Ingénieur structures', 'Ingénieur d\'études', 'Directeur de travaux', 'Conducteur de travaux', 'Maître d\'oeuvre', 'Maître d\'ouvrage'];
exports.ingenieur_jobs = ingenieur_jobs;
var technician_jobs = ['Projeteur', 'Dessinateur', 'BIM manager'];
exports.technician_jobs = technician_jobs;
var jobs = [{
  id: 1,
  label: 'BIM manager',
  value: 'BIM manager'
}, {
  id: 2,
  label: 'Chef de projet',
  value: 'Chef de projet'
}, {
  id: 3,
  label: 'Conducteur de travaux',
  value: 'Conducteur de travaux'
}, {
  id: 4,
  label: 'Consultant',
  value: 'Consultant'
}, {
  id: 5,
  label: 'Dessinateur',
  value: 'Dessinateur'
}, {
  id: 6,
  label: 'Directeur de projet',
  value: 'Directeur de projet'
}, {
  id: 7,
  label: 'Directeur de travaux',
  value: 'Directeur de travaux'
}, {
  id: 8,
  label: 'Ingénieur d\'affaires',
  value: 'Ingénieur d\'affaires'
}, {
  id: 9,
  label: 'Ingénieur d\'études',
  value: 'Ingénieur d\'études'
}, {
  id: 10,
  label: 'Ingénieur structures',
  value: 'Ingénieur structures'
}, {
  id: 11,
  label: 'Maître d\'oeuvre',
  value: 'Maître d\'oeuvre'
}, {
  id: 12,
  label: 'Maître d\'ouvrage',
  value: 'Maître d\'ouvrage'
}, {
  id: 13,
  label: 'Projeteur',
  value: 'Projeteur'
}, {
  id: 14,
  label: 'Autre',
  value: 'other'
}];
exports.jobs = jobs;
var disciplines = [{
  id: 1,
  label: 'Automatique',
  value: 'Automatique'
}, {
  id: 2,
  label: 'Aéronautique / Aérospatial',
  value: 'Aéronautique / Aérospatial'
}, {
  id: 3,
  label: 'Génie civil',
  value: 'Génie civil'
}, {
  id: 4,
  label: 'Génie mécanique',
  value: 'Génie mécanique'
}, {
  id: 5,
  label: 'Autre',
  value: 'other'
}];
exports.disciplines = disciplines;
var experiences = [{
  id: 1,
  label: 'Moins de 2 ans',
  value: 'Moins de 2 ans'
}, {
  id: 2,
  label: '2 à 5 ans',
  value: '2 à 5 ans'
}, {
  id: 3,
  label: '6 à 10 ans',
  value: '6 à 10 ans'
}, {
  id: 4,
  label: '11 à 20 ans',
  value: '11 à 20 ans'
}, {
  id: 5,
  label: '+ de 20 ans',
  value: '+ de 20 ans'
}];
exports.experiences = experiences;